/**
 * MD-136 hotfix: intercom.js is loaded via dynamic import (src/index.js), so
 * `window.Intercom` does not exist until that chunk resolves. Code that runs
 * during initial mount (FuseLayout, launcher buttons, MaintenancePage) or on
 * early auth events (JWTService logout) must await this before calling
 * window.Intercom.
 *
 * The dynamic import is cached by webpack and shared with src/index.js, so
 * this never double-loads the chunk; it resolves as soon as the module has
 * evaluated (the Intercom snippet assigns window.Intercom synchronously).
 * If the chunk fails to load, the promise rejects and callers skip
 * registration instead of crashing.
 */
let readyPromise = null;

const intercomReady = () => {
    if (!readyPromise) {
        readyPromise = import('./intercom');
    }
    return readyPromise;
};

export default intercomReady;
